import { render, staticRenderFns } from "./receipt-situation.vue?vue&type=template&id=6bea2d24&scoped=true&"
import script from "./receipt-situation.vue?vue&type=script&lang=js&"
export * from "./receipt-situation.vue?vue&type=script&lang=js&"
import style0 from "./receipt-situation.vue?vue&type=style&index=0&id=6bea2d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bea2d24",
  null
  
)

export default component.exports